// prettier-ignore
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; /* eslint-disable-line no-useless-escape */

export const isInsideIframe = () => {
  if (window.IS_STORYBOOK) return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return date.toLocaleString("en-US", options).replace(" at ", " ");
};

export const formatDateCompressed = (date: string) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.toLocaleDateString("en-us", { month: "short" });
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${year}. ${month} ${day}. ${hours}:${minutes}`;
};

export const isEmailInvalid = (email: string) => {
  return !EMAIL_REGEX.test(email);
};
